import { Link } from "react-router-dom";
import { useState } from "react";
import { TechProjectLogo } from "../images/index";

const firstMenu = [
  { name: "About Us", href: "/About" },
  { name: "Success Stories", href: "#" },
  { name: "Careers", href: "/Careers" },
  { name: "Blog / Insights", href: "#" },
  { name: "Contact", href: "/Contact" },
];

const servicesMenu = [
  { name: "Global Capability Centers (GCCs)", href: "/Services/GCC" },
  { name: "Digital Strategy & Transformation", href: "/Services/DST" },
  { name: "CyberSecurity & Compliance", href: "/Services/CSC" },
  {
    name: "Platform Engineering & Product Development",
    href: "/Services/PE&PD",
  },
  { name: "Staffing & Workforce Solutions", href: "/Services/SWS" },
];

const industriesMenu = [
  { name: "Retail & Wholesale Grocery", href: "/Industries/RWG" },
  { name: "Government & Public Sector", href: "/Industries/GPS" },
  { name: "Healthcare & Life Sciences", href: "/Industries/HLS" },
  { name: "Logistics & Supply Chain", href: "/Industries/LSC" },
  { name: "Financial Services", href: "/Industries/FS" },
];

function Footer() {
  return (
    <footer className="bg-footerBg text-gray-300 py-10 px-6 md:px-20 font-roboto">
      <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto flex flex-col md:flex-row justify-between gap-10 pb-8">
        <div className="md:w-[30%] grid justify-center items-start md:justify-start">
          <img
            src={TechProjectLogo}
            alt="TechProjects Logo"
            className="w-[14rem] md:w-46"
          />
          <div className="flex justify-between space-x-5 text-lg text-[#fff]">
            {/* <a
              href="#"
              className="hover:text-white"
              target="_blank"
              title="Youtube"
            >
              <i className="fab fa-youtube"></i>
            </a> */}
            {/* <a href="#" className="hover:text-white">
              <i className="fab fa-facebook-f"></i>
            </a> */}

            <a
              href="https://www.linkedin.com/company/techprojects/"
              className="hover:text-white py-3 px-4 bg-[#ffffff14] rounded"
              target="_blank"
              title="LinkedIn"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a
              href="https://www.instagram.com/techprojects_gcc/"
              className="hover:text-white py-3 px-4 bg-[#ffffff14] rounded"
              target="_blank"
              title="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://x.com/TechProjectsDev "
              className="hover:text-white py-3 px-4 bg-[#ffffff14] rounded"
              target="_blank"
              title="Twitter"
            >
              <i className="fa-brands fa-x-twitter"></i>
            </a>
          </div>
        </div>

        <div className="w-full md:w-[70%] flex flex-col md:flex-row justify-between gap-10">
          <div>
            <ul className="space-y-5">
              {firstMenu.map((item, index) => (
                <li key={index} className="text-white font-500 text-md">
                  <a href={item.href}>{item.name}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-500 mb-3">Services</h4>
            <ul className="space-y-5">
              {servicesMenu.map((item, index) => (
                <li key={index} className="text-[#E2E8F0] font-400 text-md">
                  <a href={item.href}>{item.name}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-3">
              Industries We Serve
            </h4>
            <ul className="space-y-5">
              {industriesMenu.map((item, index) => (
                <li key={index} className="text-[#E2E8F0] font-400 text-md">
                  <a href={item.href}>{item.name}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto text-md text-[#E2E8F0] font-roboto mt-6 px-4 md:px-0 space-y-4 md:space-y-0">
        <div className="flex flex-col md:flex-row justify-between">
          <div>
            © Copyright {new Date().getFullYear()} TechProjects. All rights
            reserved.
          </div>

          <div className="flex gap-3 flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-6 text-[#E2E8F0]">
            <a href="/TermsofService" className="hover:text-white">
              Terms of Service
            </a>
            <a href="/PrivacyPolicy" className="hover:text-white">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white">
              Manage Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
